import './OverlayTiles.css';
import { canUseDOM, get, injectImageResolution } from '../../utils';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import ScrollAnimation from 'react-animate-on-scroll';
import RouterLink from '../atoms/RouterLink';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import LazyPicture from '../atoms/LazyPicture';
import React, { useEffect, useRef, useState } from 'react';
import throttle from 'lodash/throttle';
import { convertToAnalyticObject } from '../../utils/analytics';
;
;
const OverlayTiles = _ref => {
  let {
    fields,
    params
  } = _ref;
  const cards = get(fields, 'data.item.tiles.items', []);
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const wrapperRef = useRef(null);
  const [itemSubTitleHeight, setItemSubTitleHeight] = useState(0);
  const [itemTitleHeight, setItemTitleHeight] = useState(0);
  const [itemDescHeight, setItemDescHeight] = useState(0);
  const [itemBtnHeight, setItemBtnHeight] = useState(0);
  let countHeights;
  if (canUseDOM) {
    countHeights = throttle(() => {
      if (wrapperRef.current) {
        let subTitle = 0,
          title = 0,
          desc = 0,
          btn = 0;
        const subTitleList = wrapperRef.current.querySelectorAll('.overlay-tiles-subtitle');
        subTitleList.forEach(el => {
          const subTitleHeight = el.clientHeight;
          if (subTitle < subTitleHeight) subTitle = subTitleHeight;
        });
        const titleList = wrapperRef.current.querySelectorAll('.overlay-tiles-title');
        titleList.forEach(el => {
          const titleHeight = el.clientHeight;
          if (title < titleHeight) title = titleHeight;
        });
        const descList = wrapperRef.current.querySelectorAll('.overlay-tiles-description');
        descList.forEach(el => {
          const descHeight = el.clientHeight;
          if (desc < descHeight) desc = descHeight;
        });
        const buttonList = wrapperRef.current.querySelectorAll('.overlay-tiles-button');
        buttonList.forEach(el => {
          const btnHeight = el.clientHeight;
          if (btn < btnHeight) btn = btnHeight;
        });
        setItemSubTitleHeight(subTitle);
        setItemTitleHeight(title);
        setItemDescHeight(desc);
        setItemBtnHeight(btn);
      }
    }, 300);
  }
  useEffect(() => {
    if (canUseDOM) {
      setTimeout(countHeights, 500);
      window.addEventListener('resize', countHeights);
    }
    return () => {
      window.removeEventListener('resize', countHeights);
    };
  }, []);
  useEffect(() => {
    setTimeout(countHeights, 500);
  }, [sitecoreContext.selectedFontSize]);
  const colClasses = {
    1: 'col-lg-12',
    2: 'col-lg-6',
    3: 'col-lg-4'
  };
  if (!fields.data.item) {
    return /*#__PURE__*/React.createElement("div", null);
  }
  if (!fields) {
    console.info('OverlayTiles component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [OverlayTiles component is empty: please provide data source]");
    }
    return null;
  }
  let eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  const renderTiles = () => {
    if (cards.length) {
      return cards.map((item, index) => {
        const title = item.title.jss;
        const subtitle = item.subtitle.jss;
        const description = item.description.jss;
        const backgroundImage = item.backgroundImage.jss.value;
        const ctaLabel = item.ctaLabel.jss.value;
        const cTALink = item.cTALink.jss.value;
        const hasSubTitle = item.subtitle.jss.value;
        const hasDescription = item.backgroundImage.jss.value.src;
        return /*#__PURE__*/React.createElement("div", {
          key: title.value,
          style: {
            padding: 0
          },
          className: `overlay-tile col-xs-12 col-md-12 ${colClasses[`${cards.length}`]} ${rtl ? overlayTileRtl : overlayTileLtr}`
        }, /*#__PURE__*/React.createElement("div", {
          className: "overlay-tile-content-wrapper"
        }, /*#__PURE__*/React.createElement("div", {
          className: `overlay-tile-content`
        }, /*#__PURE__*/React.createElement(ScrollAnimation, {
          animateIn: "animate__fadeInUp",
          className: "overlay-tiles-subtitle-container",
          animateOnce: true,
          duration: 1
        }, hasSubTitle ? /*#__PURE__*/React.createElement(Text, {
          tag: "h5",
          className: 'overlay-tiles-subtitle',
          field: subtitle
        }) : null), /*#__PURE__*/React.createElement(ScrollAnimation, {
          animateIn: "animate__fadeInUp",
          className: "overlay-tiles-title-container",
          animateOnce: true,
          duration: 1
        }, /*#__PURE__*/React.createElement(Text, {
          tag: "h2",
          className: 'overlay-tiles-title',
          field: title
        })), /*#__PURE__*/React.createElement("div", {
          className: "overlay-tiles-description--wrapper"
        }, /*#__PURE__*/React.createElement(ScrollAnimation, {
          animateIn: "animate__fadeInUp",
          className: "overlay-tiles-description-container",
          animateOnce: true,
          duration: 1
        }, hasDescription ? /*#__PURE__*/React.createElement(Text, {
          tag: "p",
          className: 'overlay-tiles-description',
          field: description
        }) : null)), /*#__PURE__*/React.createElement("div", {
          className: "overlay-tiles-btn--wrapper"
        }, /*#__PURE__*/React.createElement(ScrollAnimation, {
          animateIn: "animate__fadeInUp",
          className: "overlay-tiles-button-container",
          animateOnce: true,
          duration: 1
        }, /*#__PURE__*/React.createElement(RouterLink, {
          className: "overlay-tiles-button btn",
          href: cTALink.href,
          title: ctaLabel,
          linktype: cTALink.linktype,
          linksTarget: cTALink.target,
          onClick: () => tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['buttonAnalytics'], params), [title.value, ctaLabel])
        }, ctaLabel)))), /*#__PURE__*/React.createElement(LazyPicture, {
          className: 'overlay-tile-image'
        }, /*#__PURE__*/React.createElement("source", {
          media: "(min-width: 768px)",
          srcSet: `${injectImageResolution(backgroundImage.src, 1650, 928)}`
        }), /*#__PURE__*/React.createElement("img", {
          src: `${injectImageResolution(backgroundImage.src, 768, 432)}`,
          alt: backgroundImage.alt
        }))));
      });
    } else {
      return /*#__PURE__*/React.createElement("div", null);
    }
  };
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    fullWidth: true,
    className: commonStyles,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: 'overlay-tiles-container',
    ref: wrapperRef,
    style: {
      '--item-sub-height': itemSubTitleHeight,
      '--item-title-height': itemTitleHeight,
      '--item-desc-height': itemDescHeight,
      '--item-btn-height': itemBtnHeight
    }
  }, renderTiles()));
};
const commonStyles = "corpcpx";
const overlayTileRtl = "o1ilmsk";
const overlayTileLtr = "o1wmvxcn";
export default OverlayTiles;